namespace $.$$ {

	export class $shm_hitalama_map_widget_float_form_custom extends $.$shm_hitalama_map_widget_float_form_custom {

		field_link_content( name: string, link: string ) {
			const field = ( this.custom() as $shm_hitalama_map_widget_entity_table2_dataset ).field?.( name )
			if( !field ) return [ this.field_link_options( name )[ link ] ?? link ]
			return this.$.$shm_hitalama_map_widget_entity_table2_display_content(
				this.map(), null, this.widget(), this, field, link,
			)
		}

		override Atom_link( name: string ) {
			const relation = super.Atom_link( name )
			relation.item_content = ()=> this.field_link_content( name, relation.value() )
			relation.option_content = link => this.field_link_content( name, link )
			return relation
		}

		override List_link( name: string ) {
			const relation = super.List_link( name )
			relation.item_content = link => this.field_link_content( name, link )
			return relation
		}
		controls() { return [ this.Widget_page() ] }
		head_showed() { return false }
		fullsize_height() { return this.auto_height() && !this.fullscreen_attr() ? '' : '100%' }
		
		@ $mol_mem
		custom() {
			return this.widget().form_custom()
		}

		field_names(): string[] {
			return this.custom().input_field_names()
		}

		form_fields(): readonly ( any )[] {
			return this.field_names().map( str => this.Field( str ) )
		}

		field_type( id: string ) {
			const field = this.custom().field_type( id )
			return field
		}

		field_name( name: any ): string {
			return name
		}

		field_link_options( name: string ) {
			const table = this.field_source_table()
			if( table ) {
				const dataset_link = table.col_relation_dataset( name )
				const dataset = this.map().Datasets()?.remote_list().find( item => item.link().str === dataset_link )
				if( dataset ) {
					const selected = table.col_relation_display_field( name )
					const display = dataset.fields().find( field => field.link().str === selected )
					return Object.fromEntries( dataset.records().map( ( record: $shm_hitalama_map_widget_entity_table2_record ) => [ record.link().toString(), dataset.record_title( record, display ) ] ) )
				}
			}
			return this.custom().field_link_options( name )
		}

		field_select_dictionary( name: string ) {
			const values = this.custom().field_select_options( name )
			return Object.fromEntries( ( values.length ? values : this.field_source_table()?.col_select_options( name ) ?? [] )
				.map( value => [ value, value ] ) )
		}

		field_source_table() {
			const direct = this.widget().Source_table()?.remote()
			if( direct ) return direct
			return this.map().Widgets_list()?.remote_list()
				.find( widget => widget.type() === 'table' && widget.table().form_custom()?.link().str === this.custom().link().str )
				?.table() ?? null
		}

		@ $mol_mem
		field_relation_target( next?: { name: string, link: string, widget: string } | null ) {
			return next === undefined ? null : next
		}

		field_relation_active( name: string ) {
			const target = this.field_relation_target()
			if( !target || target.name !== name ) return ''
			return this.map().Widgets_list()?.remote_list().some( widget => widget.link().str === target.widget )
				? target.link : ''
		}

		@ $mol_action
		field_relation_open( name: string, link?: string ) {
			if( link === undefined ) return ''
			const current = this.field_relation_target()
			if( current ) {
				const widget = this.map().Widgets_list()?.remote_list().find( widget => widget.link().str === current.widget )
				if( widget ) this.map().widget_cut( widget.link() )
				this.field_relation_target( null )
				if( current.name === name && current.link === link ) return link
			}
			const source = this.field_source_table()
			const dataset_link = source?.col_relation_dataset( name )
			const custom = this.custom()
			const dataset = custom instanceof $shm_hitalama_map_widget_entity_table2_dataset
				? custom.field_target_dataset( name )
				: this.map().Datasets()?.remote_list().find( item => item.link().str === dataset_link )
			if( !dataset ) return link
			const record = dataset.records().find( ( record: $shm_hitalama_map_widget_entity_table2_record ) => record.link().str === new $giper_baza_link( link ).str )
			if( !dataset || !record ) {
				$shm_hitalama_notifications.warning( 'Связанная запись не найдена' )
				return link
			}
			const widget = this.map().widget_add(
				'form2', [ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ], 450, 780,
			)!
			widget.title( this.field_link_options( name )[ link ] ?? dataset.record_title( record ) )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			widget.Record2( null )?.val( new $giper_baza_link( record.link().str ) )
			this.field_relation_target({ name, link, widget: widget.link().str })
			if( this.$.$mol_state_arg.value( 'fullscreen_widget' ) === this.widget().link_str() ) {
				this.Map_page().go_to_widget( widget.link() )
			}
			return link
		}

		@ $mol_action
		field_relation_create( name: string, event?: Event ) {
			if( event === undefined ) return null
			const custom = this.custom()
			const source_field = custom instanceof $shm_hitalama_map_widget_entity_table2_dataset ? custom.field( name ) : null
			const source_record = this.widget().Record2()?.remote()
			const dataset = source_field?.target_dataset()
			if( !dataset || !source_field || !source_record ) {
				$shm_hitalama_notifications.warning( 'Сначала сохраните запись и выберите связанную таблицу' )
				return event
			}
			dataset.draft_relation_prepare( source_field, source_record )
			const widget = this.map().widget_add( 'form2',
				[ this.widget().body_x() + this.widget().right_edge_x(), this.widget().body_y() ], 450, 780 )!
			widget.title( 'Новая запись' )
			widget.Dataset( null )?.val( new $giper_baza_link( dataset.link().str ) )
			widget.Relation_source_record( null )?.val( new $giper_baza_link( source_record.link().str ) )
			widget.Relation_source_field( null )?.val( new $giper_baza_link( source_field.link().str ) )
			if( this.$.$mol_state_arg.value( 'fullscreen_widget' ) === this.widget().link_str() ) this.Map_page().go_to_widget( widget.link() )
			return event
		}

		field_list_value( name: string, next?: readonly string[] ) {
			const value = this.field_value( name, next )
			return Array.isArray( value ) ? value : []
		}

		field_number( name: string, next?: number ) {
			const value = this.field_value( name, next === undefined ? undefined : Number.isNaN( next ) ? '' : next )
			return value === '' || value == null ? NaN : Number( value )
		}

		@ $mol_mem_key
		field_json( name: string, next?: string ) {
			if( next === undefined ) {
				const value = this.data_value( name )
				return value && typeof value === 'object' ? JSON.stringify( value, null, '\t' ) : String( value || '' )
			}
			const value = this.$.$mol_error_fence(
				()=> JSON.parse( next ),
				()=> null,
			)
			if( value && !Array.isArray( value ) && typeof value === 'object' ) this.data_value( name, value )
			return next
		}

		field_bid( name: string ) {
			if( this.field_type( name ) === 'json' ) {
				const value = this.field_json( name ).trim()
				if( !value && !this.custom().field_required( name ) ) return ''
				const parsed = this.$.$mol_error_fence( ()=> JSON.parse( value ), ()=> null )
				if( !parsed || Array.isArray( parsed ) || typeof parsed !== 'object' ) return 'Введите JSON-объект'
			}
			if( !this.custom().field_required( name ) ) return ''

			const value = this.field_type( name ) === 'file'
				? this.field_files( name )
				: this.field_value( name )
			if( Array.isArray( value ) ) return value.length ? '' : '*'
			return String( value ?? '' ).trim() ? '' : '*'
		}
		pb_map_id() { return this.map().link().toString() }
		pb_widget_id() { return this.widget().link().toString() }

		@ $mol_mem_key
		Content_by_type( name: string ) {
			return super.Content_by_type( name )
		}

		Field_content( name: string ) {
			const type = this.field_type( name )
			if( type === 'custom' ) return this.String( name )
			const content = this.Content_by_type( name )
			return content[ type as keyof typeof content ]
		}

		@ $mol_mem_key
		field_value( name: any, next?: any ) {
			const type = this.field_type( name )

			if( type == 'file' ) {
				if( next === '' ) {
					this.field_files( name, [] )
					return this.data_value( name, '' )
				}
				const file = this.field_file( name )
				return this.data_value( name, file?.link().toString() )
			}
			if( type == 'file_pb' && next === '' ) return this.data_value( name, '' )

			const value = this.data_value( name, next )
			if( type === 'date' && next === undefined && typeof value === 'string' ) {
				const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec( value )
				if( match ) return `${ match[3] }-${ match[2] }-${ match[1] }`
			}
			return value
		}

		@ $mol_mem_key
		data_value( name: any, next?: any ) {
			if( this.widget().Data_method()?.val() ) {
				const object = this.widget().data() ?? {}
				if( next === undefined ) {
					if( object[ name ] !== undefined ) return object[ name ] ?? ''

					const legacy = this.custom().object_current_value( name )
					if( legacy !== undefined && legacy !== '' ) {
						this.widget().data({ ...object, [ name ]: legacy })
						return legacy
					}

					return ''
				}

				this.widget().data({ ...object, [ name ]: next })
				return next
			}

			return this.custom().object_current_value( name, next )
		}

		@ $mol_action
		fields_clear() {
			this.field_names().forEach( name => {
				this.field_value( name, '' )
				if( this.field_type( name ) == 'file_pb' ) this.File_pb( name ).form_reset()
			} )
		}

		@ $mol_action
		clear() {
			this.fields_clear()
			this.submit_result( '' )
		}

		clear_button_visible() { return this.clear_asked() ? [] : [ this.Clear() ] }
		clear_confirm_visible() { return this.clear_asked() ? [ this.Clear_confirm(), this.Clear_cancel() ] : [] }

		@ $mol_action
		clear_ask( event?: Event ) {
			if( event ) this.clear_asked( true )
			return event ?? null
		}

		@ $mol_action
		clear_cancel( event?: Event ) {
			if( event ) this.clear_asked( false )
			return event ?? null
		}

		@ $mol_action
		clear_confirm( event?: Event ) {
			if( event ) {
				this.clear()
				this.clear_asked( false )
			}
			return event ?? null
		}

		@ $mol_mem_key
		field_file( n: string ) {
			const file_native = this.field_files( n )[0]
			if( !file_native ) return null

			const file = this.map().Files(null)?.make( null )
			file?.write( file_native )

			return file!
		}

		form_object() {
			return Object.fromEntries( this.field_names().map( name => {

				const type = this.field_type( name )

				if( type == 'date' ) {
					const value = this.field_value( name )
					const moment = new $mol_time_moment( value )
					return [ name, value ? moment.toString( 'DD.MM.YYYY' ) : '' ]
				}

				return [ name, this.field_value( name ) ]

			} ) )
		}

		@ $mol_action
		submit() {
			if( !this.submit_allowed() ) return

			const obj = this.form_object()

			if( this.widget().Data_method()?.val() ) {
				this.widget().data( obj )
				this.submit_result( '' )
				$shm_hitalama_notifications.success( 'Запись обновлена' )
			} else {
				this.custom().obj_add( obj )
				this.fields_clear()
				const message = `Создана запись №${ this.custom().objects().length }`
				this.submit_result( message )
				$shm_hitalama_notifications.success( message )
			}
		}

		submit_result_visible() {
			return this.submit_result() ? super.submit_result_visible() : []
		}

		buttons() {
			return this.buttons_visible() ? super.buttons() : []
		}

		buttons_visible( next?: boolean ): boolean {
			if( next === undefined ) return !this.custom().hide_buttons()
				
			return !this.custom().hide_buttons( !next )
		}
		
	}

}
